/**
 * @param {*} store
 * @param {
 *   'always'
 *   | 'never'
 *   | 'gt_sm'
 *   | 'gt_md'
 *   | 'gt_lg'
 *   | 'gt_xl'
 *   | 'lt_sm'
 *   | 'lt_md'
 *   | 'lt_lg'
 *   | 'lt_xl'
 * } displaySettingVal
 */
export default function isScreenConditionTrue(store, displaySettingVal) {
  if (displaySettingVal === 'always') return true;
  if (displaySettingVal === 'never') return false;

  const [ltOrGt, breakpoint] = displaySettingVal.split('_');
  const isBreakpointActive = store.getters['ui/isBreakpointActive'](breakpoint);
  return isBreakpointActive
    ? ltOrGt === 'gt'
    : ltOrGt === 'lt';
}
'always' | 'never' | 'gt_sm' | 'gt_md' | 'gt_lg' | 'gt_xl' | 'lt_sm' | 'lt_md' | 'lt_lg' | 'lt_xl'
